import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ReactComponent as CloseBtn } from './../../../../assets/icons/close.svg';
import PostLoginPostApi from './../../../../components/Api/PostLoginPostApi';
import BlackButton from './../../../../components/BlackButton';
import HashLoader from "react-spinners/HashLoader";

import init from './../../AccessControl/Check';
import { MAX_UPLOAD_FILE_SIZE } from '../../../../components/Constants/FileUpload';


const UpdateBusinessCategory = () => {

    const pageName = "Business Category Update";
    const isAccess = init(pageName);

    const state = useLocation();
    const navigate = useNavigate();
    const [id, setId] = useState("");

    const [loading, setLoading] = useState(false);


    const fileInput = useRef();
    const [file, setFile] = useState("");
    
    const selectFile = () => {
        fileInput.current.click();
    }
    
    const handleChange = (e) => {
        if( !e.target?.files[0] ) {
            return;
        }

        if (!e.target.files[0]["type"].includes("image/")) {
            toast.error("Please upload valid Image file.");
            return;
        }

        if(e.target.files[0]["size"] > MAX_UPLOAD_FILE_SIZE) {
            toast.error("Max upload file size is 1 MB.");
            return;
        }
        
        setFile(e.target.files[0]);
    }

    const cancelFile = () => {
        setFile();
        fileInput.current.value = "";
    }
    
    const [input, setInput] = useState({
        name: "",
        position: ""
    });

    const onSubmit = (e) => {
        e.preventDefault();

        if (id === "") {
            toast.error("No category id found.");
            return;
        }

        if (input?.name === "") {
            toast.error("Please enter category name.");
            return;
        }

        
        setLoading(true);

        let requestBody = new FormData();
        requestBody.append("name", input.name);
        requestBody.append("position", input.position ?? null);

        if(file !== null && file !== undefined && file !== "") {
            requestBody.append("icon", file);
        }


        // Update Category API
        PostLoginPostApi("business/category/" + id, requestBody, 3, 1).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    toast.success("Category updated successfully.");
                    navigate("/dashboard/category");
                    return;
                }

                toast.error( (responseData["message"].toString() ??  responseData["messages"].toString()) + "");
            }
        }).catch((error) => {
            console.log(error);
        }).finally(()=>{
            setLoading(false);
        });
    }



    useEffect(() => {
        if (state?.state?.data?.id === undefined) {
            return navigate("/dashboard/category");
        }

        if (state?.state?.data?.name === undefined) {
            return navigate("/dashboard/category");
        }

        setId(state.state.data.id);
        setInput({name: state.state.data.name, position: state.state.data.position ?? ""});

    }, [navigate, state]);

    if (isAccess === false) {
        return (<>
            <table className="custom-details-table w-full mt-0 mb-2">
                <tbody>
                    <tr>
                        <td className="font-semibold text-base">
                            You do not have any access !
                        </td>
                    </tr>
                </tbody>
            </table>
        </>);
    }

    
    return (
        <div className='flex justify-center items-center w-full h-screen'>
        {(loading) ?
        <HashLoader
            color={"#1882FF"}
            loading={loading}
            size={200}
            aria-label="Loading Spinner"
            data-testid="loader"
        />
            :
            <div className="font-medium min-h-[100vh] w-[100%] h-[100%] custom-container-left custom-scroll-auto">
                <header className="p-4 border-b-2 border-dark-white mb-[60px]">
                    <Link to="/dashboard/category"><CloseBtn className="float-left" /></Link>
                    <p className="text-center">Update Business Category</p>
                </header>
                <main className="max-w-2xl m-auto">
                    <form onSubmit={onSubmit}>
                        
                        <h1 className="text-lg">Business Category Name</h1>
                        <div className="mt-2 mb-[15px]">
                            <input type="text" name="name" placeholder="Enter Business Category Name *" value={input?.name} 
                            onChange={(event) => setInput({...input, name: event.currentTarget.value})} 
                            className="w-full mb-2.5 rounded border-solid border border-dark-white placeholder:text-ash" required />
                        </div>

                        <h1 className="text-lg">Business Category Icon</h1>
                        <div className="flex pb-2 pt-1 mb-3 items-center">
                            <div className="flex items-center relative w-[49.5%] bg-[#f5f5f5] p-2 rounded-md" style={{ border: "1px solid #e0e0e0" }}>
                                <input type="file" className="hidden" name="icon" ref={fileInput} onChange={handleChange} />
                                <label htmlFor="icon" className="p-1 text-base font-medium">Icon</label>
                                {file ?
                                    <>
                                        <img src={URL.createObjectURL(file)} alt="Preview Icon" className="max-h-10 max-w-[70px] ml-auto order-3" />
                                        <p style={{ fontSize: "10px" }} onClick={() => cancelFile()} className="text-red-700 font-semibold cursor-pointer">cancel</p>
                                        <button type="button" className="text-white ml-auto order-3 bg-[#444] py-[10px] px-[50px] rounded-[3px] cursor-pointer block justify- text-xs" onClick={selectFile}>Change</button>
                                    </> :
                                    <>
                                        <button type="button" className="text-white ml-auto order-2 bg-[#1A202C] py-[10px] px-[25px] rounded-[3px] cursor-pointer block justify- text-base" onClick={selectFile}>Update</button>
                                    </>
                                }

                            </div>

                            <div className="relative w-[49.5%] p-2 rounded-md ml-auto">
                                {(state?.state?.data?.icon) && 
                                    <img src={state?.state?.data?.icon} alt="Category Icon" className="float-left max-h-10 max-w-10 ml-auto order-3" />
                                }
                            </div>
                        </div>


                        <h1 className="text-lg">Business Category Position</h1>
                        <div className="mt-2 mb-[25px]">
                            <input type="number" name="position" value={input?.position} 
                            onChange={(event) => setInput({...input, position: event.currentTarget.value?? ""})} 
                            placeholder="Enter Business Category Position" className="w-full mb-2.5 rounded border-solid border border-dark-white placeholder:text-ash" />
                        </div>

                        <BlackButton name="Update Business Category" />
                    </form>
                        
                </main>
            </div>
        }
        </div>
    );
};

export default UpdateBusinessCategory;